import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { useUserContext } from '../Components/StateContext/UserContext';
import { RouteComponentProps, withRouter, useParams } from 'react-router-dom';
import RestService from '../Services/RestService';

interface TileSpec {
  label: string;
  icon: string;
  href?: string;
  disabled: boolean;
  hidden?: boolean;
  badge?: number;
}

const TILES_PER_ROW = 3;

const badgeStyle: React.CSSProperties = {
  position: 'absolute',
  top: '0.5rem',
  right: '0.5rem',
  minWidth: '1.5rem',
  height: '1.5rem',
  padding: '0 0.4rem',
  borderRadius: '0.75rem',
  background: '#2a2859',
  color: '#fff',
  fontSize: '0.8rem',
  fontWeight: 700,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1,
};

const renderTile = (tile: TileSpec, key: number) => {
  const card = (
    <div className="ods-status-card frontpage-card" style={{ position: 'relative' }}>
      {tile.badge != null && tile.badge > 0 && (
        <span style={badgeStyle} aria-label={`${tile.badge} meldinger`}>{tile.badge}</span>
      )}
      <div className="ods-status-card__content">
        <span className={`ods-icon ods-icon--size-kilo ods-icon--size-echo-breakpoint-medium ${tile.icon}`} aria-hidden="true"></span>
        <span className="ods-text--size-kilo ods-text--size-echo-breakpoint-medium">{tile.label}</span>
      </div>
    </div>
  );
  return (
    <div key={key} className={tile.disabled ? "ods-grid__column--4 ods-color-text-grayscale-10" : "ods-grid__column--4"}>
      {tile.disabled || !tile.href ? card : (
        <a href={tile.href} className="o-kom-link" style={{ display: 'block' }}>{card}</a>
      )}
    </div>
  );
};

const FrontpageView: React.FC<RouteComponentProps> = (props) => {
  const { depId, classId, week } = useParams<{ depId: string; classId: string; week: string }>();
  const { department, userRoles } = useUserContext();

  const isParentOnly = userRoles.length > 0 && userRoles.every(r => r === 'parent');
  const isAdmin = userRoles.includes('admin');
  const isAdminOrLocalAdmin = isAdmin || userRoles.includes('localadmin');

  const [mailCount, setMailCount] = useState<number | undefined>(undefined);

  useEffect(() => {}, [depId, classId, week, department]);

  useEffect(() => {
    if (!isAdmin) return;
    RestService.get<number>('/api/mailbox/Count')
      .then(setMailCount)
      .catch(() => { /* badge is best-effort; ignore errors */ });
  }, [isAdmin]);

  const tiles: TileSpec[] = [
    { label: 'Fravær',                icon: 'ods-icon--success-square',                                              disabled: true },
    { label: 'Brukersøk',             icon: 'ods-icon--magnifying-glass-big',                                        disabled: true },
    { label: 'Min side',              icon: 'ods-icon--user',               href: '/myuserdetails',                  disabled: false },
    { label: 'Rapporter',             icon: 'ods-icon--graph',              href: '/reports',                         disabled: !isAdminOrLocalAdmin },
    { label: 'Konfigurasjon',         icon: 'ods-icon--tool',               href: '/config',                          disabled: !isAdminOrLocalAdmin },
    { label: 'Rom booking',           icon: 'ods-icon--calendar',                                                    disabled: true },
    { label: 'Opprett bruker',        icon: 'ods-icon--plus-sign',                                                   disabled: true },
    { label: 'Betalinger',            icon: 'ods-icon--coin-stacks',                                                 disabled: true },
    { label: 'Felles epost',          icon: 'ods-icon--email',              href: '/fellesepost',                    disabled: !isAdmin, hidden: !isAdmin, badge: mailCount },
    { label: 'Eksamensregistrering',  icon: 'ods-icon--document',           href: '/examregistration',               disabled: false },
    { label: 'Idrettsregistrering',   icon: 'ods-icon--document',           href: '/athleticsregistration',          disabled: false },
  ];

  const visible = tiles.filter(t => !t.hidden);
  const sorted = [...visible].sort((a, b) => Number(a.disabled) - Number(b.disabled));

  const rows: TileSpec[][] = [];
  for (let i = 0; i < sorted.length; i += TILES_PER_ROW) {
    rows.push(sorted.slice(i, i + TILES_PER_ROW));
  }

  return (
    <>
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="ods-grid ods-grid--gap-row-large ods-margin-top-25 ods-text--align-center">
          <div className="ods-grid__column--12">
            <div className="ods-grid ods-grid--gap ods-grid--center">
              {row.map((tile, colIndex) => renderTile(tile, rowIndex * TILES_PER_ROW + colIndex))}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default withRouter(FrontpageView);
